var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('mastercontent', {
    attrs: {
      "data-list": _vm.signOffList,
      "headers": _vm.headers,
      "writeRightProp": _vm.writeRight,
      "componentId": "midwifeSignOff"
    },
    on: {
      "openNew": _vm.openNew,
      "open": _vm.open,
      "remove": _vm.remove
    },
    scopedSlots: _vm._u([{
      key: "mdt.from",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('dateitem', {
          attrs: {
            "date-item": item.from
          }
        })];
      }
    }, {
      key: "mdt.until",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('dateitem', {
          attrs: {
            "date-item": item.until
          }
        })];
      }
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }